import { useState, useEffect } from 'react';
import axios from 'axios';
import { toast, Toaster } from 'sonner';
import { LandingCarrusel } from '@/components/LandingCarrusel';
import { LandingMenu } from '@/components/LandingMenu';
import { LandingTestimonios } from '@/components/LandingTestimonios';

const API = process.env.REACT_APP_BACKEND_URL;
const WA = '50254307807';
const AZUL = '#1FA3E8';
const A = 'https://customer-assets-lqy194kg.emergentagent.net/job_social-crm-3/artifacts';

const IMG = {
  logo: `${A}/ckf7btpo_c3217efc-1851-4a8d-8daf-e535de3c5dd6.jpeg`,
  hero: `${A}/2hu6rcej_6245a9c8-1654-45eb-8aa0-c44e265b2b1f.jpeg`,
  corrediza: 'https://static.prod-images.emergentagent.com/jobs/f8421f9d-b7ab-4b05-852e-30567b337ae5/images/b8711aca19210921637dbdbdf6c9e4198413239d646f67c2fa1b6fde626d76cd.jpeg',
  abatible: 'https://static.prod-images.emergentagent.com/jobs/f8421f9d-b7ab-4b05-852e-30567b337ae5/images/41d35b1a8355c4c7ecb6f1aa5fe4e417cd6ad1ae5df3b6e460b40eea6636138a.jpeg',
  instalada: `${A}/5swq7unz_860ea87c-e27b-4833-8394-105734c630ca.jpeg`,
  sandblast: `${A}/4z4fq740_363bfbf7-3442-4695-94a5-cb54bc27b80e.jpeg`,
  bisagraCromada: 'https://static.prod-images.emergentagent.com/jobs/f8421f9d-b7ab-4b05-852e-30567b337ae5/images/dda746296fd1d106a1d8d8b477f05e5393926437061b4b3cf66f0e05e797153d.jpeg',
  bisagraSatinada: 'https://static.prod-images.emergentagent.com/jobs/f8421f9d-b7ab-4b05-852e-30567b337ae5/images/dc04c7f9ef54aa0d689b7e1f335a057268bdd37ef95d2694746b2432f507c74c.jpeg',
  bisagraNegra: 'https://static.prod-images.emergentagent.com/jobs/f8421f9d-b7ab-4b05-852e-30567b337ae5/images/e47811b1b7b8a2995015eb1541eac092f6e557f3be546601fcb80965fdf3a5f9.jpeg',
};

const CARRUSEL_INICIAL = [
  { url: `${A}/cwb53c9s_1b0aa0c8-eeb0-4f20-9a8b-8656c96412bc.jpeg`, caption: 'Mampara abatible con herrajes satinados' },
  { url: `${A}/uhd7zggf_3d42ae9f-4c58-4189-a825-d3f088130c3a.jpeg`, caption: 'Ducha corrediza esquinera' },
  { url: `${A}/4aryqpv6_20e13590-2357-415e-ae38-adb9b7402c79.jpeg`, caption: 'Ducha semicircular corrediza' },
  { url: `${A}/t3u1p9vl_6d4c5563-1ed2-4ce5-a124-536f82016158.jpeg`, caption: 'Vidrio curvo templado para ducha' },
  { url: `${A}/wroiq9hx_edf55191-3f5e-4b6d-9b1f-f5abd43c1f10.jpeg`, caption: 'Mampara fija con puerta abatible' },
];

const DEPARTAMENTOS = ['Guatemala', 'Sacatepéquez', 'Chimaltenango', 'Escuintla', 'Santa Rosa', 'Sololá', 'Totonicapán', 'Quetzaltenango', 'Suchitepéquez', 'Retalhuleu', 'San Marcos', 'Huehuetenango', 'Quiché', 'Baja Verapaz', 'Alta Verapaz', 'Petén', 'Izabal', 'Zacapa', 'Chiquimula', 'Jalapa', 'Jutiapa', 'El Progreso'];

const waLink = (text) => `https://wa.me/${WA}?text=${encodeURIComponent(text)}`;

const HERRAJES = [
  { nombre: 'Cromado', desc: 'Brillo espejo clásico que combina con cualquier grifería.', img: 'bisagraCromada' },
  { nombre: 'Satinado', desc: 'Acabado mate elegante que disimula gotas y huellas.', img: 'bisagraSatinada' },
  { nombre: 'Negro', desc: 'El favorito de los baños modernos e industriales.', img: 'bisagraNegra' },
];

export default function LandingDuchas() {
  const [form, setForm] = useState({ nombre: '', telefono: '', departamento: '', detalles: '' });
  const [sending, setSending] = useState(false);
  const [done, setDone] = useState(null);

  useEffect(() => {
    axios.post(`${API}/api/landing/track`, { producto: 'duchas_mamparas' }).catch(() => {});
  }, []);

  const set = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.value }));

  const submit = async (e) => {
    e.preventDefault();
    if (!form.nombre.trim() || !form.telefono.trim() || !form.departamento) {
      toast.error('Completa tu nombre, teléfono y departamento');
      return;
    }
    try {
      setSending(true);
      const res = await axios.post(`${API}/api/landing/duchas/lead`, form);
      setDone(res.data);
    } catch (err) {
      toast.error(err?.response?.data?.detail || 'Error enviando, intenta de nuevo');
    } finally { setSending(false); }
  };

  return (
    <div style={{ fontFamily: "'Inter', system-ui, sans-serif" }} className="min-h-screen bg-[#080B10] text-white">
      <Toaster position="top-center" richColors />
      <style>{`@keyframes deslizarX{0%,100%{transform:translateX(0)}50%{transform:translateX(10px)}}`}</style>

      {/* Top bar */}
      <header className="sticky top-0 z-40 bg-[#080B10]/90 backdrop-blur border-b border-white/10">
        <div className="max-w-6xl mx-auto px-4 py-2.5 flex items-center justify-between">
          <div className="flex items-center gap-3">
            <img src={IMG.logo} alt="Soluciones Arquitectónicas" className="h-10 sm:h-11 w-auto rounded" data-testid="header-logo" />
            <p className="hidden sm:block text-[10px] text-white/50 tracking-[0.25em] uppercase border-l border-white/15 pl-3">Modernizando ambientes</p>
          </div>
          <div className="flex items-center gap-2">
            <LandingMenu actual="/duchasymamparas" />
            <a href={waLink('¡Hola! Vi la página de duchas y mamparas de vidrio templado y quiero una cotización 😊')}
              target="_blank" rel="noreferrer" data-testid="wa-header-btn"
              className="bg-[#25D366] hover:brightness-110 text-white text-sm font-bold px-4 py-2 rounded-full transition-all">
              WhatsApp
            </a>
          </div>
        </div>
      </header>

      {/* Hero */}
      <section className="relative">
        <img src={IMG.hero} alt="Mampara de ducha de vidrio templado" className="w-full h-[64vh] object-cover object-center opacity-70" />
        <div className="absolute inset-0 bg-gradient-to-t from-[#080B10] via-[#080B10]/45 to-[#080B10]/25" />
        <div className="absolute inset-0 flex items-end">
          <div className="max-w-6xl mx-auto px-4 pb-10 w-full">
            <p style={{ color: AZUL }} className="font-bold text-xs tracking-[0.3em] uppercase mb-3">Transforma tu baño</p>
            <h1 className="text-4xl sm:text-5xl lg:text-6xl font-black leading-[1.05] max-w-3xl">
              Bañeras, Duchas y <span style={{ color: AZUL }}>Mamparas</span> de Vidrio Templado
            </h1>
            <p className="text-white/70 text-base mt-4 max-w-xl">
              Corredizas y abatibles en vidrio templado de 6mm, 8mm y 10mm. Vidrio claro, bronce o gris, con film de diseño u opaco tipo sandblast. Modernizando ambientes.
            </p>
            <div className="flex gap-3 mt-6 flex-wrap">
              <a href="#cotizar" data-testid="hero-cta"
                style={{ background: AZUL }}
                className="hover:brightness-110 text-white font-black px-6 py-3 rounded-full text-sm transition-all">
                COTIZA GRATIS →
              </a>
              <a href={waLink('¡Hola! Quiero cotizar una mampara de vidrio templado para mi baño 😊')} target="_blank" rel="noreferrer"
                className="border border-white/25 hover:border-white/60 text-white font-bold px-6 py-3 rounded-full text-sm transition-colors">
                Escríbenos por WhatsApp
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* Stats strip */}
      <section style={{ background: AZUL }} data-testid="stats-strip">
        <div className="max-w-6xl mx-auto px-4 py-6 grid grid-cols-2 md:grid-cols-4 gap-4 text-center">
          {[
            ['6-8-10mm', 'espesores según el sistema'],
            ['3 colores', 'de vidrio: claro, bronce y gris'],
            ['3 acabados', 'herrajes cromados, satinados y negros'],
            ['+18 años', 'de experiencia instalando'],
          ].map(([n, t]) => (
            <div key={n}>
              <p className="text-2xl sm:text-3xl font-black leading-none">{n}</p>
              <p className="text-white/90 text-xs sm:text-sm font-medium mt-1">{t}</p>
            </div>
          ))}
        </div>
      </section>

      {/* Tipos: corrediza vs abatible */}
      <section className="max-w-6xl mx-auto px-4 py-14" data-testid="seccion-tipos">
        <p style={{ color: AZUL }} className="font-bold text-xs tracking-[0.3em] uppercase mb-2 text-center">A la medida de tu baño</p>
        <h2 className="text-2xl sm:text-3xl font-black text-center mb-8">Corredizas o <span style={{ color: AZUL }}>abatibles</span></h2>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          <div className="bg-white/[0.04] border border-white/10 rounded-3xl overflow-hidden" data-testid="card-corrediza">
            <img src={IMG.corrediza} alt="Ducha corrediza de vidrio templado" className="w-full h-64 object-cover object-center" />
            <div className="p-6">
              <p className="font-black text-lg">Corredizas <span style={{ color: AZUL }} className="text-sm">· 6mm, 8mm y 10mm</span></p>
              <p className="text-white/55 text-sm mt-2 leading-relaxed">
                Ideales para baños compactos: la puerta se desliza sin invadir espacio. Sistema de rodos y barra de acero inoxidable, suaves y silenciosas.
              </p>
            </div>
          </div>
          <div className="bg-white/[0.04] border border-white/10 rounded-3xl overflow-hidden" data-testid="card-abatible">
            <img src={IMG.abatible} alt="Mampara abatible de vidrio templado" className="w-full h-64 object-cover object-center" />
            <div className="p-6">
              <p className="font-black text-lg">Abatibles <span style={{ color: AZUL }} className="text-sm">· 8mm y 10mm</span></p>
              <p className="text-white/55 text-sm mt-2 leading-relaxed">
                Apertura amplia y elegante con bisagras de presión. Perfectas para duchas amplias, esquineras y baños tipo spa.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Templado vs vidrio crudo */}
      <section className="max-w-6xl mx-auto px-4 pb-14" data-testid="seccion-seguridad">
        <div className="bg-white/[0.04] border border-white/10 rounded-3xl p-6 sm:p-10">
          <p style={{ color: AZUL }} className="font-bold text-xs tracking-[0.3em] uppercase mb-2 text-center">Seguridad ante todo</p>
          <h2 className="text-2xl sm:text-3xl font-black text-center">¿Por qué templado y no <span style={{ color: AZUL }}>vidrio crudo</span>?</h2>
          <p className="text-white/60 text-base text-center max-w-2xl mx-auto mt-4">
            La ducha es una zona de riesgo: el piso mojado y con jabón puede provocar caídas contra el vidrio. Por eso <span className="text-white/85 font-bold">nunca se debe instalar vidrio crudo (normal) en una ducha</span> — el templado protege tu vida y la de tu familia.
          </p>
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 mt-8">
            {[
              ['Resiste mucho más', 'El vidrio templado soporta golpes e impactos que quebrarían fácilmente un vidrio crudo normal.'],
              ['Si se rompe, te protege', 'El templado se fragmenta en piezas pequeñas sin filos peligrosos. El vidrio crudo se quiebra en pedazos grandes y cortantes: el riesgo de una herida grave es mucho mayor.'],
              ['Barra de seguridad', 'Recomendamos instalar una barra de apoyo dentro de la ducha para sostenerse y prevenir caídas. Nosotros la instalamos junto con tu mampara.'],
            ].map(([t, d], i) => (
              <div key={t} className="bg-black/25 border border-white/10 rounded-2xl p-5" data-testid={`seguridad-${i}`}>
                <p style={{ color: AZUL }} className="text-2xl font-black leading-none mb-2">{String(i + 1).padStart(2, '0')}</p>
                <p className="font-black text-sm sm:text-base">{t}</p>
                <p className="text-white/55 text-sm mt-2 leading-relaxed">{d}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Acabados del vidrio */}
      <section className="max-w-6xl mx-auto px-4 pb-14 grid grid-cols-1 md:grid-cols-2 gap-10 items-center" data-testid="seccion-acabados">
        <figure className="rounded-3xl overflow-hidden border border-white/10 order-1 md:order-none">
          <img src={IMG.sandblast} alt="Mampara de vidrio opaco tipo sandblast" className="w-full h-[400px] object-cover object-center" />
          <figcaption className="bg-black/60 text-xs text-white/70 px-4 py-2 font-bold">Vidrio opaco tipo sandblast: privacidad total</figcaption>
        </figure>
        <div>
          <p style={{ color: AZUL }} className="font-bold text-xs tracking-[0.3em] uppercase mb-3">Elige tu estilo</p>
          <h2 className="text-2xl sm:text-3xl font-black leading-tight">Acabados del <span style={{ color: AZUL }}>vidrio</span></h2>
          <div className="space-y-4 mt-6">
            {[
              ['Vidrio templado claro', 'La opción más luminosa: tu baño se ve más amplio. Disponible también en tono bronce y gris.'],
              ['Film con diseño', 'Franjas, patrones o diseños personalizados aplicados al vidrio para dar estilo y privacidad parcial.'],
              ['Opaco tipo sandblast', 'Todo el vidrio esmerilado para privacidad total sin sacrificar la entrada de luz.'],
            ].map(([t, d], i) => (
              <div key={t} className="flex gap-4 bg-white/[0.04] border border-white/10 rounded-2xl p-4" data-testid={`acabado-${i}`}>
                <p style={{ color: AZUL }} className="text-xl font-black leading-none">{String(i + 1).padStart(2, '0')}</p>
                <div>
                  <p className="font-black text-sm">{t}</p>
                  <p className="text-white/55 text-sm mt-1 leading-relaxed">{d}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Herrajes en colores */}
      <section className="max-w-6xl mx-auto px-4 pb-14" data-testid="seccion-herrajes">
        <p style={{ color: AZUL }} className="font-bold text-xs tracking-[0.3em] uppercase mb-2 text-center">Bisagras y herrajes</p>
        <h2 className="text-2xl sm:text-3xl font-black text-center mb-2">Herrajes en el color de <span style={{ color: AZUL }}>tu baño</span></h2>
        <p className="text-white/50 text-sm text-center mb-8">Color oro disponible bajo pedido especial.</p>
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-5">
          {HERRAJES.map((h) => (
            <div key={h.nombre} className="bg-white/[0.04] border border-white/10 rounded-3xl overflow-hidden hover:border-[#1FA3E8]/40 transition-colors" data-testid={`herraje-${h.nombre.toLowerCase()}`}>
              <img src={IMG[h.img]} alt={`Bisagra para ducha acabado ${h.nombre.toLowerCase()}`} className="w-full h-52 object-cover" />
              <div className="p-5">
                <p className="font-black text-base">{h.nombre}</p>
                <p className="text-white/55 text-sm mt-1.5 leading-relaxed">{h.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* Carrusel */}
      <section className="pb-14" data-testid="carrusel-proyectos">
        <div className="max-w-6xl mx-auto px-4 flex items-end justify-between gap-4">
          <div>
            <p style={{ color: AZUL }} className="font-bold text-xs tracking-[0.3em] uppercase mb-2">Proyectos reales</p>
            <h2 className="text-2xl sm:text-3xl font-black mb-6">Inspírate para tu <span style={{ color: AZUL }}>baño</span></h2>
          </div>
          <p className="text-white/60 text-sm font-bold mb-6 shrink-0 flex items-center gap-1" data-testid="deslizar-hint">
            Deslizar <span style={{ color: AZUL, animation: 'deslizarX 1.2s ease-in-out infinite', display: 'inline-block' }} className="font-black text-lg">→</span>
          </p>
        </div>
        <LandingCarrusel producto="duchas_mamparas" initial={CARRUSEL_INICIAL} />
      </section>

      {/* Cuidados + guía PDF */}
      <section className="max-w-6xl mx-auto px-4 pb-14 grid grid-cols-1 md:grid-cols-2 gap-10 items-center">
        <div>
          <p style={{ color: AZUL }} className="font-bold text-xs tracking-[0.3em] uppercase mb-3">¡Somos Profesionales!</p>
          <h2 className="text-2xl sm:text-3xl font-black leading-tight">Tu mampara puede durar <span style={{ color: AZUL }}>décadas</span></h2>
          <p className="text-white/60 text-base mt-4">
            El baño es el ambiente más agresivo para el vidrio y los herrajes: el jabón, el shampoo y el cloro del agua provocan corrosión y el temido "ojo de pescado" (manchas de minerales incrustadas en el cristal). Con el cuidado correcto, eso no pasa.
          </p>
          <div className="bg-white/[0.04] border border-white/10 rounded-2xl p-5 mt-5" data-testid="guia-card">
            <p className="font-black text-sm">📘 Manual de Mantenimiento GRATIS</p>
            <p className="text-white/55 text-sm mt-1.5">
              Al comprar con nosotros recibes el manual para proteger tu inversión: cómo evitar la corrosión de los herrajes y el ojo de pescado en el cristal, y <span className="text-white/80 font-bold">por qué nunca debes usar limpiavidrios comerciales con químicos o amoníaco</span>.
            </p>
            <a href={`${API}/api/landing/guia-duchas`} data-testid="guia-download-btn"
              className="inline-block mt-3 border border-[#1FA3E8] text-[#1FA3E8] hover:bg-[#1FA3E8] hover:text-white font-black px-5 py-2.5 rounded-full text-xs transition-colors">
              DESCARGAR MANUAL PDF
            </a>
          </div>
        </div>
        <figure className="rounded-3xl overflow-hidden border border-white/10">
          <img src={IMG.instalada} alt="Mampara de ducha instalada profesionalmente" className="w-full h-[420px] object-cover object-center" />
        </figure>
      </section>

      {/* Testimonios */}
      <section className="max-w-6xl mx-auto px-4 pb-14" data-testid="seccion-testimonios">
        <p style={{ color: AZUL }} className="font-bold text-xs tracking-[0.3em] uppercase mb-2 text-center">Lo que dicen nuestros clientes</p>
        <h2 className="text-2xl sm:text-3xl font-black text-center mb-8">Clientes que confiaron <span style={{ color: AZUL }}>en nosotros</span></h2>
        <LandingTestimonios producto="duchas_mamparas" initial={[
            {
              nombre: 'Lucía Ramírez',
              texto: 'Cambiamos la cortina de baño por una mampara corrediza de 8mm y el baño se ve de revista. La instalación fue en un día y dejaron todo limpio.',
            },
            {
              nombre: 'Fernando Castillo',
              texto: 'Pedimos vidrio sandblast para privacidad y herrajes negros para combinar con la grifería. Nos asesoraron súper bien y el resultado quedó exactamente como queríamos.',
            },
            {
              nombre: 'Mariana López',
              texto: 'Nos regalaron el manual de mantenimiento y ha sido clave: la mampara sigue como nueva después de un año, sin manchas ni herrajes oxidados. Muy profesionales.',
            },
          ]} color={AZUL} />
      </section>

      {/* FAQ */}
      <section className="max-w-3xl mx-auto px-4 pb-14" data-testid="seccion-faq">
        <p style={{ color: AZUL }} className="font-bold text-xs tracking-[0.3em] uppercase mb-2 text-center">Resolvemos tus dudas</p>
        <h2 className="text-2xl sm:text-3xl font-black text-center mb-8">Preguntas <span style={{ color: AZUL }}>frecuentes</span></h2>
        <div className="space-y-3">
          {[
            ['¿Cuánto cuesta una mampara de vidrio templado?',
              'Depende de las medidas, el sistema (corredizo o abatible), el espesor y el acabado del vidrio y los herrajes. La cotización es GRATIS — envíanos medidas o fotos de tu baño por WhatsApp y te respondemos el mismo día.'],
            ['¿Qué es mejor: corrediza o abatible?',
              'Si tu baño es compacto, la corrediza aprovecha mejor el espacio. Si tienes una ducha amplia o esquinera, la abatible da una apertura más cómoda y elegante. Te asesoramos según tu espacio, sin costo.'],
            ['¿Qué opciones tengo para más privacidad?',
              'Puedes elegir vidrio opaco completo tipo sandblast, o aplicar film con diseño (franjas o patrones). También hay vidrio en tono bronce o gris que reduce la visibilidad manteniendo la luz.'],
            ['¿Por qué se manchan los vidrios y herrajes de las duchas?',
              'El jabón, el shampoo y el cloro del agua generan corrosión en los herrajes y "ojo de pescado" en el cristal (manchas de minerales). Por eso entregamos un manual de mantenimiento gratis: con secado rápido y los productos correctos tu mampara dura décadas.'],
            ['¿Cómo empiezo mi proyecto?',
              'Llena el formulario de esta página o escríbenos al WhatsApp 5430-7807. Vamos, medimos, te cotizamos y coordinamos la instalación de principio a fin.'],
          ].map(([q, a], i) => (
            <details key={q} className="group bg-white/[0.04] border border-white/10 rounded-2xl overflow-hidden" data-testid={`faq-item-${i}`}>
              <summary className="flex items-center justify-between gap-4 cursor-pointer px-5 py-4 font-bold text-sm sm:text-base list-none [&::-webkit-details-marker]:hidden hover:bg-white/[0.03] transition-colors">
                {q}
                <span style={{ color: AZUL }} className="text-xl font-black shrink-0 group-open:rotate-45 transition-transform">+</span>
              </summary>
              <p className="px-5 pb-5 text-white/65 text-sm leading-relaxed">{a}</p>
            </details>
          ))}
        </div>
      </section>

      {/* Formulario */}
      <section id="cotizar" className="max-w-2xl mx-auto px-4 pb-16">
        <div className="bg-white/[0.05] border border-white/10 rounded-3xl p-6 sm:p-8">
          {done ? (
            <div className="text-center py-6" data-testid="lead-success">
              <p className="text-5xl mb-4">✅</p>
              <h3 className="text-2xl font-black">¡Recibido, {form.nombre.split(' ')[0]}!</h3>
              <p className="text-white/60 text-sm mt-2 mb-6">Un asesor te contactará muy pronto. Si quieres respuesta inmediata, continúa por WhatsApp:</p>
              <a href={done.wa_link} target="_blank" rel="noreferrer" data-testid="lead-wa-btn"
                className="inline-block bg-[#25D366] hover:brightness-110 text-white font-black px-8 py-3 rounded-full text-sm transition-all">
                💬 Continuar en WhatsApp
              </a>
            </div>
          ) : (
            <>
              <h2 className="text-2xl font-black">Cotiza tu mampara <span style={{ color: AZUL }}>GRATIS</span></h2>
              <p className="text-white/50 text-sm mt-1 mb-6">Sin compromiso. Te contactamos por WhatsApp o llamada.</p>
              <form onSubmit={submit} className="space-y-4">
                <div>
                  <label className="text-xs font-bold text-white/60 uppercase tracking-wide">Tu nombre *</label>
                  <input value={form.nombre} onChange={set('nombre')} data-testid="lead-nombre" placeholder="Ej: Carlos Pérez"
                    className="mt-1 w-full bg-black/30 border border-white/15 focus:border-[#1FA3E8] rounded-xl px-4 py-3 text-sm text-white outline-none transition-colors" />
                </div>
                <div>
                  <label className="text-xs font-bold text-white/60 uppercase tracking-wide">Teléfono / WhatsApp *</label>
                  <input value={form.telefono} onChange={set('telefono')} data-testid="lead-telefono" placeholder="Ej: 5555 5555" inputMode="tel"
                    className="mt-1 w-full bg-black/30 border border-white/15 focus:border-[#1FA3E8] rounded-xl px-4 py-3 text-sm text-white outline-none transition-colors" />
                </div>
                <div>
                  <label className="text-xs font-bold text-white/60 uppercase tracking-wide">¿En qué departamento estás? *</label>
                  <select value={form.departamento} onChange={set('departamento')} data-testid="lead-departamento" style={{ colorScheme: 'dark' }}
                    className="mt-1 w-full bg-black/30 border border-white/15 focus:border-[#1FA3E8] rounded-xl px-4 py-3 text-sm text-white outline-none transition-colors">
                    <option value="">Selecciona…</option>
                    {DEPARTAMENTOS.map((d) => <option key={d} value={d}>{d}</option>)}
                  </select>
                </div>
                <div>
                  <label className="text-xs font-bold text-white/60 uppercase tracking-wide">Detalles de tu proyecto</label>
                  <textarea value={form.detalles} onChange={set('detalles')} data-testid="lead-detalles" rows={3}
                    placeholder="Ej: mampara corrediza de 1.20 x 1.90 metros, vidrio claro con herrajes negros…"
                    className="mt-1 w-full bg-black/30 border border-white/15 focus:border-[#1FA3E8] rounded-xl px-4 py-3 text-sm text-white outline-none transition-colors resize-none" />
                </div>
                <button type="submit" disabled={sending} data-testid="lead-submit"
                  style={{ background: AZUL }}
                  className="w-full hover:brightness-110 disabled:opacity-60 text-white font-black py-3.5 rounded-xl text-sm transition-all">
                  {sending ? 'Enviando…' : 'QUIERO MI COTIZACIÓN GRATIS'}
                </button>
              </form>
            </>
          )}
        </div>
      </section>

      {/* Footer */}
      <footer className="border-t border-white/10 py-6 text-center text-xs text-white/40">
        Soluciones Arquitectónicas · Modernizando ambientes · Grupo SACH · Guatemala · WhatsApp +502 5430 7807 · +18 años de experiencia
      </footer>

      {/* WhatsApp flotante */}
      <a href={waLink('¡Hola! Vi la página de duchas y mamparas de vidrio templado y quiero una cotización 😊')}
        target="_blank" rel="noreferrer" data-testid="wa-float-btn" aria-label="WhatsApp"
        className="fixed bottom-5 right-5 z-50 bg-[#25D366] hover:scale-110 transition-transform w-14 h-14 rounded-full flex items-center justify-center shadow-2xl">
        <svg viewBox="0 0 32 32" width="30" height="30" fill="#fff"><path d="M16 3C9.4 3 4 8.4 4 15c0 2.1.6 4.2 1.7 6L4 29l8.2-1.6c1.2.6 2.5.9 3.8.9 6.6 0 12-5.4 12-12S22.6 3 16 3zm0 22c-1.2 0-2.4-.3-3.5-.8l-.6-.3-4.9 1 1-4.7-.3-.6C6.6 18.1 6 16.6 6 15 6 9.5 10.5 5 16 5s10 4.5 10 10-4.5 10-10 10zm5.5-7.5c-.3-.2-1.8-.9-2-1-.3-.1-.5-.2-.7.2-.2.3-.8 1-.9 1.1-.2.2-.3.2-.6.1-.3-.2-1.3-.5-2.4-1.5-.9-.8-1.5-1.8-1.7-2.1-.2-.3 0-.5.1-.6l.5-.5c.2-.2.2-.3.3-.5.1-.2 0-.4 0-.6l-1-2.3c-.2-.6-.5-.5-.7-.5h-.6c-.2 0-.5.1-.8.4-.3.3-1 1-1 2.5s1.1 2.9 1.2 3.1c.2.2 2.1 3.2 5.1 4.5.7.3 1.3.5 1.7.6.7.2 1.4.2 1.9.1.6-.1 1.8-.7 2-1.4.3-.7.3-1.3.2-1.4-.1-.1-.3-.2-.6-.4z"/></svg>
      </a>
    </div>
  );
}
